import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { EXPERT_REPORT_COMPARE_WITH, useExportFileDownload } from '@features/expertReports'
import type { ReportExportFormat } from '@features/expertReports'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { EXPERT_TRIAL_BALANCE_COMPARE_COUNT, fetchExpertTrialBalanceExport } from '../query-api'
import { useExpertTrialBalanceParams } from './useExpertTrialBalanceParams'

interface UseDownloadExpertTrialBalanceExportResult {
  downloadExport: (format: ReportExportFormat) => Promise<void>
  isExporting: boolean
}

export const useDownloadExpertTrialBalanceExport = (): UseDownloadExpertTrialBalanceExportResult => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { hideZeroes, period, search } = useExpertTrialBalanceParams()

  const fetchExport = useCallback(
    (format: ReportExportFormat) =>
      fetchExpertTrialBalanceExport({
        compareCount: EXPERT_TRIAL_BALANCE_COMPARE_COUNT,
        compareWith: EXPERT_REPORT_COMPARE_WITH,
        format,
        hideZeroes,
        organizationId: organization?.id ?? '',
        period,
        search: search || undefined,
      }),
    [hideZeroes, organization?.id, period, search],
  )

  return useExportFileDownload({
    errorMessage: t('expert_trial_balance.export.error'),
    fetchExport,
    isReady: !!organization?.id && !!period,
    notificationKey: NotificationKeys.ExpertTrialBalanceExport,
  })
}
